import { render } from "./AllInOneBankVerificationReport.vue?vue&type=template&id=ef13bc00"
import script from "./AllInOneBankVerificationReport.vue?vue&type=script&lang=js"
export * from "./AllInOneBankVerificationReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__